var map = {
	"./calendar/en": "ILt5",
	"./calendar/en.js": "ILt5",
	"./calendar/es": "CCKS",
	"./calendar/es.js": "CCKS",
	"./de": "v7I9",
	"./de.js": "v7I9",
	"./en": "SqxG",
	"./en.js": "SqxG",
	"./es": "sr2Q",
	"./es.js": "sr2Q",
	"./fr": "dCuN",
	"./fr.js": "dCuN",
	"./it": "0L0R",
	"./it.js": "0L0R",
	"./pt": "4K5m",
	"./pt.js": "4K5m"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Fevk";


//////////////////
// WEBPACK FOOTER
// ./resources/js/i18n ^\.\/.*$
// module id = Fevk
// module chunks = 3 4 6